import {createRouter, createWebHistory} from 'vue-router'
import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('@/home.vue'),
        redirect: '/main?v='+new Date().getTime(),
        children: [{
                path: '/main',
                name: 'main',
                component: () => import('@/main.vue')
            }, {
                path: '/auth/userList',
                component: () => import('@/view/auth/userList.vue')
            }, {
                path: '/auth/authorizeByUser',
                component: () => import('@/view/auth/authorizeByUser.vue')
            }, {
                path: '/auth/authorizeBySystem',
                name: 'authorizeBySystem',
                component: () => import('@/view/auth/authorizeBySystem.vue')
            }, {
                path: '/payment/editPayment',
                name: 'editPayment',
                component: () => import('@/view/payment/editPayment.vue')
            }, {
                path: '/payment/myPaymentList',
                name: 'myPaymentList',
                component: () => import('@/view/payment/myPaymentList.vue')
            }, {
                path: '/payment/allPaymentList',
                name: 'allPaymentList',
                component: () => import('@/view/payment/allPaymentList.vue')
            }, {
                path: '/payment/viewPayment',
                name: 'viewPayment',
                component: () => import('@/view/payment/viewPayment.vue')
            }, {
                path: '/procurement/allProcurementList',
                name: 'allProcurementList',
                component: () => import('@/view/procurement/allProcurementList.vue')
            }, {
                path: '/procurement/myProcurementList',
                name: 'myProcurementList',
                component: () => import('@/view/procurement/myProcurementList.vue')
            }, {
                path: '/procurement/editProcurement',
                name: 'editProcurement',
                component: () => import('@/view/procurement/editProcurement.vue')
            }, {
                path: '/procurement/viewProcurement',
                name: 'viewProcurement',
                component: () => import('@/view/procurement/viewProcurement.vue')
            }, {
                path: '/investment/myInvestmentList',
                name: 'myInvestmentList',
                component: () => import('@/view/investment/myInvestmentList.vue')
            }, {
                path: '/investment/allInvestmentList',
                name: 'allInvestmentList',
                component: () => import('@/view/investment/allInvestmentList.vue')
            }, {
                path: '/investment/viewInvestment',
                name: 'viewInvestment',
                component: () => import('@/view/investment/viewInvestment.vue')
            }, {
                path: '/investment/editInvestment',
                name: 'editInvestment',
                component: () => import('@/view/investment/editInvestment.vue')
            }, {
                path: '/broker/brokerStatementList',
                name: 'brokerStatmentList',
                component: () => import('@/view/broker/brokerStatementList.vue')
            }, {
                path: '/broker/editBrokerStatement',
                name: 'editBrokerStatement',
                component: () => import('@/view/broker/editBrokerStatement.vue')
            }, {
                path: '/report/reportList',
                name: 'reportList',
                component: () => import('@/view/report/reportList.vue')
            }, {
                path: '/report/viewReport',
                name: 'viewReport',
                component: () => import('@/view/report/viewReport.vue')
            }, {
                path: '/report/createReport',
                name: 'createReport',
                component: () => import('@/view/report/createReport.vue')
            }, {
                path: '/log/allEventList',
                name: 'allEventList',
                component: () => import('@/view/log/allEventList.vue')
            }, {
                path: '/log/myEventList',
                name: 'myEventList',
                component: () => import('@/view/log/myEventList.vue')
            }, {
                path: '/log/viewEvent',
                name: 'viewEvent',
                component: () => import('@/view/log/viewEvent.vue')
            }, {
                path: '/log/editEvent',
                name: 'editEvent',
                component: () => import('@/view/log/editEvent.vue')
            }, {
                path: '/log/allInterviewList',
                name: 'allInterviewList',
                component: () => import('@/view/log/allInterviewList.vue')
            }, {
                path: '/log/myInterviewList',
                name: 'myInterviewList',
                component: () => import('@/view/log/myInterviewList.vue')
            }, {
                path: '/log/viewInterview',
                name: 'viewInterview',
                component: () => import('@/view/log/viewInterview.vue')
            }, {
                path: '/log/editInterview',
                name: 'editInterview',
                component: () => import('@/view/log/editInterview.vue')
            }, {
                path: '/deck/allDeckDocuments',
                name: 'allDeckDocuments',
                component: () => import('@/view/deck/allDeckDocuments.vue')
            }, {
                path: '/deck/myDeckDocuments',
                name: 'myDeckDocuments',
                component: () => import('@/view/deck/myDeckDocuments.vue')
            }, {
                path: '/deck/viewDeckDocument',
                name: 'viewDeckDocument',
                component: () => import('@/view/deck/viewDeckDocument.vue')
            }, {
                path: '/deck/editDeckDocument',
                name: 'editDeckDocument',
                component: () => import('@/view/deck/editDeckDocument.vue')
            }, {
                path: '/companyDoc/allCompanyDocs',
                name: 'allCompanyDocs',
                component: () => import('@/view/companyDoc/allCompanyDocs.vue')
            }, {
                path: '/companyDoc/viewCompanyDoc',
                name: 'viewCompanyDoc',
                component: () => import('@/view/companyDoc/viewCompanyDoc.vue')
            }, {
                path: '/companyDoc/editCompanyDoc',
                name: 'editCompanyDoc',
                component: () => import('@/view/companyDoc/editCompanyDoc.vue')
            }, {
                path: '/iss/topHoldingBallots',
                name: 'topHoldingBallots',
                component: () => import('@/view/iss/topHoldingBallots.vue')
            }, {
                path: '/iss/viewMeetingDetails',
                name: 'viewMeetingDetails',
                component: () => import('@/view/iss/viewMeetingDetails.vue')
            }, {
                path: '/contract/editContract',
                name: 'editContract',
                component: () => import('@/view/contract/editContract.vue')
            }, {
                path: '/contract/viewContract',
                name: 'viewContract',
                component: () => import('@/view/contract/viewContract.vue')
            }, {
                path: '/contract/allContracts',
                name: 'allContracts',
                component: () => import('@/view/contract/allContracts.vue')
            }, {
                path: '/contract/contractCalendar',
                name: 'contractCalendar',
                component: () => import('@/view/contract/contractCalendar.vue')
            }
        ]
    },
    {
        path: '/user/login',
        name: 'login',
        component: () => import('@/view/user/loginBox.vue')
    },
    {
        path: '/user/forgetPassword',
        name: 'forgetPassword',
        component: () => import('@/view/user/forgetPassword.vue')
    },
    {
        path: '/user/changePassword',
        name: 'changePassword',
        component: () => import('@/view/user/changePassword.vue')
    },
    {
        path: '/user/resetPassword',
        name: 'resetPassword',
        component: () => import('@/view/user/resetPassword.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    let noNeedCheckList = ['login', 'forgetPassword', 'resetPassword']
    if (noNeedCheckList.includes(to.name)) {
        console.log("No need check login " + to.path);
        next()
    } else {
        if (from && from.path) {
            sessionStorage.setItem("fromPath", from.path);
        } else {
            sessionStorage.removeItem("fromPath");
        }

        if (localStorage.getItem("token")) {
            console.log("check login passed");
            next();
        } else {
            let query = "";
            if (to.query) {
                for (let key in to.query) {
                    query += (query=="" ? "?" : "&") + key + "=" + to.query[key];
                }
            }
            next({
                name: 'login'
            });
            window.location = "/user/login?backURL="+encodeURIComponent(to.path+query)
        }
    }
})

router.afterEach((to, from) => {
    //全局后置钩子
})



export default router
